"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _Functions = require("UIComponents/core/Functions");

var _LegalConsent = require("FormsCommonComponents/constants/LegalConsent");

var _LegalConsent2 = _interopRequireWildcard(require("FormsCommonComponents/lib/LegalConsent"));

var _isEmpty = _interopRequireDefault(require("hs-lodash/isEmpty"));

var LegalConsentFields = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LegalConsentFields, _Component);
  (0, _createClass2.default)(LegalConsentFields, null, [{
    key: "propTypes",
    get: function get() {
      return {
        legalConsentRecord: _propTypes.default.instanceOf(_LegalConsent2.default).isRequired,
        communicationConsentCheckedState: _propTypes.default.array,
        onCommunicationCheckboxChange: _propTypes.default.func
      };
    }
  }]);

  function LegalConsentFields() {
    var _this;

    (0, _classCallCheck2.default)(this, LegalConsentFields);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LegalConsentFields).call(this));
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LegalConsentFields, [{
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(checkbox, checked, isCommunicationConsent) {
      var onCommunicationCheckboxChange = this.props.onCommunicationCheckboxChange;

      if (!isCommunicationConsent) {
        return;
      }

      (0, _Functions.callIfPossible)(onCommunicationCheckboxChange, checkbox, checked);
    }
  }, {
    key: "renderHelpText",
    value: function renderHelpText(helpText) {
      if (!helpText) {
        return null;
      }

      return _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: helpText
        }
      }));
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(name, label, helpText) {
      var _this2 = this;

      var isCommunicationConsent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var checkbox = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var communicationConsentCheckedState = this.props.communicationConsentCheckedState;
      var isChecked = false;

      if (isCommunicationConsent) {
        var currentCheckbox = (communicationConsentCheckedState || []).find(function (item) {
          return item.communicationTypeId === checkbox.communicationTypeId;
        });

        if (!(0, _isEmpty.default)(currentCheckbox)) {
          isChecked = currentCheckbox.consented;
        }
      }

      var requiredStyle = {
        color: 'red',
        'padding-left': '4px'
      };
      return _react.default.createElement("div", {
        key: name
      }, _react.default.createElement(_UICheckbox.default, {
        type: "checkbox",
        name: name,
        size: "small",
        defaultChecked: isChecked,
        onChange: function onChange(_ref) {
          var checked = _ref.target.checked;
          return _this2.handleCheckboxChange(checkbox, checked, isCommunicationConsent);
        }
      }, _react.default.createElement("div", {
        style: {
          display: 'flex'
        }
      }, _react.default.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: label
        }
      }), checkbox.required ? _react.default.createElement("span", {
        style: requiredStyle
      }, "*") : null), this.renderHelpText(helpText)));
    }
  }, {
    key: "renderText",
    value: function renderText(name, text) {
      return _react.default.createElement("p", {
        key: name,
        dangerouslySetInnerHTML: {
          __html: text
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var legalConsentRecord = this.props.legalConsentRecord;
      return _react.default.createElement("div", {
        className: "legal-consent-container"
      }, Object.values((0, _LegalConsent2.getEditableLegalConsentKeysForLegalConsentType)(legalConsentRecord.getLegalConsentType()) || {}).map(function (key) {
        switch (key) {
          case _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT:
          case _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT:
          case _LegalConsent.EditableLegalConsentKeys.PRIVACY_POLICY_TEXT:
            return _this3.renderText(key, legalConsentRecord.get(key));

          case _LegalConsent.EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES:
            return legalConsentRecord.get(key).map(function (checkbox) {
              return _this3.renderCheckbox("LEGAL_CONSENT.subscription_type_" + checkbox.communicationTypeId, checkbox.label, null, true, checkbox);
            });

          case _LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL:
            return _this3.renderCheckbox(key, legalConsentRecord.get(key), legalConsentRecord.get(_LegalConsent.EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT), false, {
              required: true
            });

          default:
            return null;
        }
      }));
    }
  }]);
  return LegalConsentFields;
}(_react.Component);

exports.default = LegalConsentFields;
module.exports = exports.default;